import React from "react";
import "./BoxTile.css";
import { primeRevealAudio } from "./revealFx";

/**
 * Kutuyu gösteren hücre.
 * PR-32 — keşfedilebilir TEK-TIK açma: kutu hazırsa (count>0) tek dokunuş açar.
 * EMİR #68a — RAF/İSTE derinliği (kırmızı rozet yerine "×N" pili), nefes +
 * mühür parıltısı + ≤14 yıldız-tozu (yalnız transform/opacity) + dökümhane
 * zemini. Ses context'i dokunma JESTİNDE prime edilir.
 * EMİR #68-REV — 🔒 KUTU KİMLİĞİ: owner'ın MY BOX sandığı; owner görsel önizlemeyle
 * seçmedikçe DEĞİŞTİRİLEMEZ (owner-görünür kimlik varlıkları deploy'dan önce onay).
 * EMİR #70 — owner 3 gpt-image-1 önizlemesinden "MY BOX Premium+"ı SEÇTİ (usta
 * yeniden-boyama: koyu ceviz + canlı mavi rün + ağır zincir + altın köşe/mühür;
 * gerçek-alpha). Yeni varsayılan = my-box-premium.webp (768px, ~156KB, alpha korundu).
 * EMİR #72 Parça D (H4, owner-onaylı 2026-07-17) — kenar-sisi temizlendi: gpt-image-1
 * çıktısının yarı-saydam matte halkası (koyu zeminde pus) alpha-eşik + lüminans/mavi
 * filtre + en-büyük-bileşen + 2px aç-kapa + kenar-tüyleme ile silindi (sis 33px→3px,
 * QC PASS; script: `scripts/box-edge-clean.js`). Aynı tasarım, temiz kenar.
 * Rollback: aşağıdaki satırı `/boxes/my-box-premium.webp`'e çevir (tek-satır geri).
 * Eski sandık `assets-archive/mystic-box.png`'de.
 */
export function boxImageFor(_boxType?: string): string {
  return "/boxes/my-box-premium-clean.webp"; // tüm tipler: owner-seçili MY BOX Premium+ (kenar-sisi temiz)
}

// Yıldız-tozu partikülleri (sabit konum/gecikme — deterministik, ≤14 kural F4).
const DUST = Array.from({ length: 8 }, (_, i) => i);

export default function BoxTile({ count = 0, onOpen = () => {}, busy = false, boxType = "standardBox" }) {
  const ready = count > 0;
  const img = boxImageFor(boxType);
  // Raf derinliği: arkada en fazla 2 kopya (count 2 → 1 kopya, 3+ → 2 kopya).
  const stack = Math.min(Math.max(count - 1, 0), 2);

  // EMİR #80-C.9 — TEK CTA: eylem YALNIZ rafın sarı AÇ butonunda (BoxShelf).
  // Kutuya dokunuş artık AÇMAZ; yalnız ses context'ini prime eder (jest bedava
  // yakalanır — koreografi sesleri raf-AÇ'tan önce de yetkilenmiş olur).
  const handleClick = () => {
    if (ready && !busy) primeRevealAudio();
  };
  void onOpen; // API geriye-uyumlu (BoxShelf hâlâ geçiyor); eylem rafın AÇ'ında

  return (
    <button
      type="button"
      className={`labubu-cell labubu-cell--box breathing ${ready ? "ready" : ""}${busy ? " opening" : ""} pressable`}
      onClick={handleClick}
      disabled={!ready || busy}
      title="Kutu"
      aria-label={ready ? `Kutu (${count}) — açmak için rafın AÇ butonunu kullan` : "Kutu"}
    >
      {/* Dökümhane zemini (vinyet) — kutunun oturduğu sahne. */}
      <span className="labubu-box-foundry" aria-hidden="true" />

      {/* Raf/iste: arkadaki kutular (derinlik hissi; kırmızı rozet EMEKLİ). */}
      {stack >= 2 && <img className="labubu-box-img labubu-box-stack labubu-box-stack--2" src={img} alt="" draggable={false} aria-hidden="true" />}
      {stack >= 1 && <img className="labubu-box-img labubu-box-stack labubu-box-stack--1" src={img} alt="" draggable={false} aria-hidden="true" />}

      <img
        className="labubu-box-img labubu-box-front"
        src={img}
        alt="MyBox"
        draggable={false}
      />

      {/* Mühür parıltısı + yıldız tozu (yalnız hazır kutuda; transform/opacity). */}
      {ready && <span className="labubu-box-seal-glow" aria-hidden="true" />}
      {ready && (
        <span className="labubu-box-dust" aria-hidden="true">
          {DUST.map((i) => <i key={i} className={`labubu-dust-p labubu-dust-p--${i}`} />)}
        </span>
      )}

      {/* Bekleyen kutu sayısı: sakin "×N" pili (rozet değil, envanter dili). */}
      {ready && count > 1 && <span className="labubu-box-countpill">×{count}</span>}

      {/* EMİR #80-C.9 — "Aç" pili TAMAMEN SİLİNDİ (çift-CTA karmaşası; eylem
          yalnız rafın sarı AÇ butonu). PR-32 keşfedilebilirlik görevi rafta. */}

      <span className="labubu-box-shadow" aria-hidden="true" />
    </button>
  );
}
